import { Box, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const ACCENT_BLUE = '#22638f';
const ACCENT_ORANGE = '#d96c3c';

function CarouselSlider({ imageList }) {
    const [arrayList, setArrayList] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const minHeight = `calc(${window.innerHeight}px - 48px)`;
    useEffect(() => {
        if (!imageList || !imageList.length) return;

        const capturedImages = imageList.filter(file =>
            file.file_name.toLowerCase().includes('captured')
        );

        const processedImages = imageList.filter(file =>
            file.file_name.toLowerCase().includes('processed')
        );

        const cvServerImages = imageList.filter(file =>
            file.file_name.toLowerCase().includes('_cv_server')
        );

        const finalList = [
            ...capturedImages,
            ...processedImages,
            ...cvServerImages,
        ];

        setArrayList(finalList);
        setCurrentImageIndex(0);
    }, [imageList]);

    const handleNextImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === arrayList.length - 1 ? 0 : prevIndex + 1
        );
    };

    const handlePrevImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? arrayList.length - 1 : prevIndex - 1
        );
    };

    const displayedImage = arrayList[currentImageIndex];

    const navButtonStyle = {
        border: 'none',
        backgroundColor: ACCENT_BLUE,
        color: '#fff',
        width: 40,
        height: 40,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        flexShrink: 0,
    };

    return (
        <div style={{ height: minHeight }}>
            {arrayList.length ? (
                <div style={{ backgroundColor: '#0e0e12', height: '100%', display: 'flex', flexDirection: 'column' }}>

                    <div
                        style={{
                            display: 'flex',
                            gap: '10px',
                            overflowX: 'auto',
                            padding: '14px 20px',
                            backgroundColor: '#17171c',
                            borderBottom: '1px solid rgba(255,255,255,0.08)',
                        }}
                    >
                        {arrayList.map((image, index) => {
                            const isActive = index === currentImageIndex;
                            return (
                                <div
                                    key={index}
                                    onClick={() => setCurrentImageIndex(index)}
                                    style={{
                                        cursor: 'pointer',
                                        flexShrink: 0,
                                        borderRadius: '8px',
                                        overflow: 'hidden',
                                        border: isActive ? `2px solid ${ACCENT_ORANGE}` : '2px solid transparent',
                                        opacity: isActive ? 1 : 0.6,
                                        transition: 'opacity 0.15s ease, border-color 0.15s ease',
                                    }}
                                >
                                    <img
                                        style={{ width: 84, height: 84, objectFit: 'cover', display: 'block' }}
                                        src={image.image}
                                        alt={`Slider ${index}`}
                                    />
                                </div>
                            );
                        })}
                    </div>

                    <div
                        style={{
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '20px',
                            padding: '20px',
                            minHeight: 0,
                        }}
                    >
                        <button style={navButtonStyle} onClick={handlePrevImage} aria-label="Previous image">
                            <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
                        </button>

                        <Box
                            sx={{
                                height: '100%',
                                maxWidth: '80%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '12px',
                                minHeight: 0,
                            }}
                        >
                            <img
                                src={displayedImage.image}
                                alt="Slider"
                                style={{ maxHeight: '85%', maxWidth: '100%', objectFit: 'contain', borderRadius: '6px' }}
                            />
                            <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, fontWeight: 600, textAlign: 'center', margin: 0 }}>
                                {displayedImage.file_name}
                            </p>
                        </Box>

                        <button style={navButtonStyle} onClick={handleNextImage} aria-label="Next image">
                            <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
                        </button>
                    </div>
                </div>
            ) : (
                <Box sx={{ m: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress sx={{ color: ACCENT_ORANGE }} />
                </Box>
            )}
        </div>
    );
}

export default CarouselSlider;